import { render, staticRenderFns } from "./HostFtpUsers.vue?vue&type=template&id=f94fbf92&scoped=true"
import script from "./HostFtpUsers.vue?vue&type=script&lang=js"
export * from "./HostFtpUsers.vue?vue&type=script&lang=js"
import style0 from "./HostFtpUsers.vue?vue&type=style&index=0&id=f94fbf92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94fbf92",
  null
  
)

export default component.exports